import script from "./TeamView.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamView.vue?vue&type=script&setup=true&lang=js"

import "./TeamView.vue?vue&type=style&index=0&id=be1bbc22&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be1bbc22"]])

export default __exports__